module.exports = __webpack_public_path__ + "static/media/147-bangladesh.994f3566.svg";